exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-b88637f0] .md-table-row.ea:hover {\n  background-color: #fafafa;\n  cursor: pointer;\n}\n", ""]);

// exports
